import { useServices } from '@/core/composables/services';
import { SendContentFeedback, SendHelpdesk, SendSupport } from '@/parts/support/gql/support';

export const useSupportStore = () => {
  const { $api } = useServices();

  const sendToSupport = (payload: {
    description: string;
    userName: string;
    phoneNumber: string;
    email: string;
    subject: string;
    attachments: File[];
  }) => {
    const result = $api.mutation(SendSupport, payload);

    return result;
  };

  const sendToHelpdesk = (payload: {
    details: string;
    description: string | null;
    userName: string;
    phoneNumber: string;
    email: string;
  }) => {
    const result = $api.mutation(SendHelpdesk, payload);

    return result;
  };

  const sendContentFeedback = (payload: {
    accomodationObjectCid: string;
    message: string;
    attachments: File[];
    userName: string;
    phoneNumber: string;
    email: string;
  }) => {
    const result = $api.mutation(SendContentFeedback, payload);

    return result;
  };

  return {
    sendToSupport,
    sendToHelpdesk,
    sendContentFeedback,
  };
};
